

import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";

import { FormInstance } from "antd";
import InterfaceComponent from "./Masters/InterfaceComponent";

export default function PerformanceRating() {
  const formRef = useRef<FormInstance>(null);
  
  return (
      <ActionHandlerProvider>
       <InterfaceComponent
          InterfaceName={"Employee Performance"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
           
          ref={formRef}
        />
        
      </ActionHandlerProvider>
  );
}
